import * as Yup from 'yup';
import ValidationService from './validation';
import UtilService from '../util';

// cod, sigla, nome, descricao, ativo
const schema = Yup.object().shape({
    hora_dia: Yup
        .number()
        .required("Campo obrigatório.")
        .min(0, "Hora por dia tem que ser maior ou igual a 0.")
        .max(24, "Hora por dia tem que ser menor ou igual a 24.")
        .integer("Hora por dia tem que ser um número inteiro."),

    hora_total: Yup
        .number()
        .required("Campo obrigatório")
        .min(0, "Hora total mensal tem que ser maior ou igual a 0.")
        .max(744, "Hora total mensal tem que ser menor ou igual a 744.")
        .integer("Hora total mensal tem que ser um número inteiro."),
    
    id_regime: Yup
        .number("Preencher com uma das opções.")
        .required("Campo obrigatório.")
        .nullable()
        .transform(UtilService.yupTransform),
    
});

async function validate(form) {
    return ValidationService.validate(form, schema);
}

async function castValues(form) {
    return ValidationService.castValues(form, schema);
}

const CargaHorariaValidation = {
    schema,
    validate,
    castValues
};

export default CargaHorariaValidation;